import { Grid } from "@mui/material";
import Title from "../../../common/Title";
import CustomizedSwitches from "@/Layouts/components/InputComponents/CustomizedSwitches";
import { updateSystemSettings } from "@/Settings/api/SystemSettings/mutations";
import { errorLogger } from "@/Common/helpers/logger";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import ToPositions from "./ToPositions";

type CommissionPayoutProps = {
	locationId: string;
	isPayFundedDealsOnly: boolean;
	toPositions?: string[];
	mappedPositions?: { systemPosition: string }[];
};

const CommissionPayout = (props: Readonly<CommissionPayoutProps>) => {
	const { locationId, isPayFundedDealsOnly, toPositions, mappedPositions } = props;
	const [isChecked, setIsChecked] = useState<boolean>(false);

	const { mutate: updateCommissionPayout, isPending } = useMutation({
		mutationFn: (input: { citCommissionPayout: { isPayFundedDealsOnly: boolean } }) =>
			updateSystemSettings(locationId, input, "CIT_COMMISSION_PAYOUT"),
		onSuccess: (result) => {
			setIsChecked(Boolean(result?.citCommissionPayout?.isPayFundedDealsOnly));
		},
		onError: (error) => errorLogger(error),
	});

	const handleCheck = (checked: boolean) => {
		setIsChecked(checked);
		updateCommissionPayout({
			citCommissionPayout: {
				isPayFundedDealsOnly: checked,
			},
		});
	};

	useEffect(() => {
		setIsChecked(!!isPayFundedDealsOnly);
	}, [isPayFundedDealsOnly]);

	return (
		<>
			<Title title="Commission Payout" className="!mb-[24px]" />
			<Grid container className="border-none gap-6" columnSpacing={2}>
				<Grid item xs={12}>
					<CustomizedSwitches
						disabled={isPending}
						textRight
						textUnChecked="Pay Funded Deals Only"
						textChecked="Pay Funded Deals Only"
						onChange={handleCheck}
						checked={isChecked}
						className="!ml-[15px] !mb-[24px]"
					/>
				</Grid>
				{isChecked && (
					<Grid item xs={12}>
						<Grid item className="position-mapping-payroll-column" sx={{ position: "relative" }}>
							<ToPositions
								toPositions={toPositions}
								locationId={locationId}
								mappedPositions={mappedPositions}
								isPayFundedDealsOnly={isPayFundedDealsOnly}
							/>
						</Grid>
					</Grid>
				)}
			</Grid>
		</>
	);
};

export default CommissionPayout;
